import { addAmplitudeLogger } from 'helpers/addAmplitudeLogger'
import { addRudderstackLogger } from 'helpers/addRudderstackLogger'
import { getCommonEventProps } from 'helpers/getCommonEventProps'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Cohort } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'
import { AMPLITUDE_API_KEY } from 'constants/rootConstants'

export const useEventLoggerInitialization = (): void => {
  const { search } = useLocation()
  const {
    cohort,
    leadId,
    country,
    firebaseRemoteConfig,
    growthbook,
    isEventLoggerInitialized,
  } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || '',
      leadId: state.lead?.id,
      country: state.lead?.country || '',
      firebaseRemoteConfig: state.firebaseRemoteConfig,
      growthbook: state.growthbook,
      isEventLoggerInitialized: state.isEventLoggerInitialized,
    })),
  )
  const { language } = useZustandSessionStore(
    useShallow((state) => ({
      language: state.language,
    })),
  )

  useEffect(() => {
    if (
      isEventLoggerInitialized ||
      !leadId ||
      !language ||
      !firebaseRemoteConfig ||
      !growthbook
    ) {
      return
    }

    const searchParams = new URLSearchParams(search)
    const searchParamsEntries = Object.fromEntries(searchParams.entries())

    eventLogger.init(
      [],
      searchParamsEntries,
      getCommonEventProps(searchParamsEntries),
    )

    addAmplitudeLogger({
      amplitudeApiKey: AMPLITUDE_API_KEY,
      cohort: cohort as Cohort,
      utmTags: searchParamsEntries,
      uuid: leadId,
      firebaseRemoteConfig,
      growthbook,
      country,
    })
    addRudderstackLogger({
      cohort: cohort as Cohort,
      utmTags: searchParamsEntries,
      uuid: leadId,
      firebaseRemoteConfig,
      growthbook,
      country,
    })

    useZustandStore.setState({ isEventLoggerInitialized: true })
  }, [
    cohort,
    country,
    firebaseRemoteConfig,
    growthbook,
    isEventLoggerInitialized,
    language,
    leadId,
    search,
  ])
}
